<template>
    <div
        :id="`notification-${notification.id}`"
        class="d-flex align-items-start bg-light mxw-100 rounded shadow-default mtsp-8 py-8 px-14"
    >
        <v-icon
            :class="colorClass"
            :name="iconName"
            class="mr-16"
            :w="30"
            :flip="notification.type === 'warning' ? 'vertical' : undefined"
        />

        <div class="d-flex flex-column w-100 mr-auto">
            <p
                v-if="notification.title"
                class="font--16 lh--20 mb-0 text-dark text-break mtsp-8"
            >
                {{ notification.title }}
            </p>

            <template v-if="infoItems.length">
                <p
                    v-if="infoItems.length == 1"
                    class="font--12 mb-0 text-gray-dark text-break mtsp-8 mtsp-12"
                >
                    {{ infoItems[0] }}
                </p>

                <ul
                    v-else
                    class="pl-10 mtsp-8 mtsp-12"
                >
                    <li
                        v-for="(line, idx) in infoItems"
                        :key="idx"
                        class="font--12 text-gray-dark"
                    >
                        {{ line }}
                    </li>
                </ul>
            </template>

            <template v-if="notification.actionText">
                <base-button
                    ref="actionText"
                    theme="secondary"
                    class="mtsp-12"
                    :min-width="140"
                    @click="callback"
                >
                    {{ notification.actionText }}
                </base-button>

                <tool-tip name="actionText">
                    {{ ucfirst(notification.actionText) }}
                </tool-tip>
            </template>
        </div>

        <button-link
            v-if="notification.showCloseButton || $mq.sMinus"
            icon="close"
            theme="dark"
            class="ml-14"
            :icon-size="20"
            @click="removeNotification"
        />
    </div>
</template>

<script>
import { ucfirst } from "~/lib/utils"
import BaseButton from "~/components/buttons/BaseButton"
import ButtonLink from "~/components/buttons/ButtonLink"
import ToolTip from "~/components/ToolTip"
/**
 * notification format is the following:
 * id: {
            type: Number,
            required: true
        },

        actionCallback: Function,
        actionText: String,
        info: [String, Array],
        showCloseButton: Boolean,
        title: String,
        type: {
            type: String,
            default: "info",
            validator(val) {
                return [
                    "success",
                    "danger",
                    "error",
                    "warning",
                    "info"
                ].includes(val)
            }
        }
 */

export default {
    props: {
        notification: {
            type: Object,
            required: true,
        },
    },

    computed: {
        iconName() {
            switch (this.notification.type) {
                case "success":
                    return "radiobutton-check-line"
                case "danger":
                case "error":
                    return "radiobutton-cross-line"
                case "warning":
                    return "exclamation-circle"
                case "info":
                    return "info"

                default:
                    throw new Error(this.notification.type)
            }
        },

        colorClass() {
            switch (this.notification.type) {
                case "success":
                    return "text-success"
                case "danger":
                case "error":
                    return "text-danger"
                case "warning":
                    return "text-warning"
                case "info":
                    return "text-info"

                default:
                    throw new Error(this.notification.type)
            }
        },

        infoItems() {
            if (!this.notification.info) return []
            if (typeof this.notification.info === "string") {
                return [this.notification.info]
            }
            return this.notification.info
        },
    },

    methods: {
        removeNotification() {
            this.$store.commit("removeNotification", this.notification.id)
        },

        callback() {
            this.notification.actionCallback &&
                this.notification.actionCallback()
            this.removeNotification()
        },

        ucfirst,
    },

    components: {
        BaseButton,
        ButtonLink,
        ToolTip,
    },
}
</script>
